import { useEffect, useState } from 'react'
import { PAGE_TRANSITION_MS } from '../routes/PageTransitionOutlet'

export function usePageExit(shouldExit: boolean, delayMs = PAGE_TRANSITION_MS) {
  const [isExiting, setIsExiting] = useState(false)
  const [isComplete, setIsComplete] = useState(false)

  useEffect(() => {
    if (!shouldExit || isComplete) {
      return
    }

    setIsExiting(true)
    const timer = window.setTimeout(() => {
      setIsComplete(true)
    }, delayMs)

    return () => clearTimeout(timer)
  }, [shouldExit, isComplete, delayMs])

  return { isExiting, isComplete }
}
